/**
 * 表格组件
 * 包含分页
 * 搜索栏可选
 */
import Tabel from './src/main';

export default Tabel
